import { GetOrderOutputsByOrderItemResponse } from "../../../../common/api/orders-api/order-output/GetOrderOutputsByOrderResponse";
import { mapNumberToOrderOutputType, OrderOutputType } from "../../../common/types/OrderOutputType";
import { OrderTransferStatus } from "../../../common/types/OrderTransferStatus";

export interface OrderOutputsListingItem {
    orderOutputType: string;
    filePath: string;
    status?: OrderTransferStatus;
    completion?: number;
}

export const mapToOrderOutputsListingItem = (response: GetOrderOutputsByOrderItemResponse): OrderOutputsListingItem => {
    const orderOutputType = OrderOutputType[mapNumberToOrderOutputType(response.type)];

    return {
        filePath: response.path,
        orderOutputType,
        status: response.status,
        completion: response.completion
    };
};
